// Dependencies
import React from 'react';
import { ThemeContext } from '../../components/theme/Theme.jsx'
import { connect } from 'react-redux';
import radium from 'radium';

import ShoppingCart from './shopping-cart/ShoppingCart.jsx';
import Separator from '../../components/separator/Separator.jsx';
import HelpInfo from '../event/HelpInfo.jsx';
import ButtonEventsOverview from '../../components/button-events-overview/ButtonEventsOverview.jsx';
import EmptyShoppingCart from './shopping-cart/EmptyShoppingCart.jsx';
import CheckoutArea from './checkout/CheckoutArea.jsx';
import Errors from '../../components/errors/Errors';
import CrossSellingEvent from "../../components/crossSellingEvent/crossSellingEvent";
import OrderComment from "../../components/orderComment/OrderComment";
import { checkIfCrossSellingEnabled } from "../../redux/crossSellingEventReducer";

// Styles
import './ShoppingCartCheckoutPage.scss';

const constructTicketAddressErrors = (ticketAddressErrors, context, errMsgs) => {
	const messages = [];
	if (Object.keys(ticketAddressErrors).length > 0) {
		messages.push({message: context.themeManager.getThemeTextOrHardcodedDefault('ticketAddressErrMsg'), elementIdToLink: 'ticket-addresses'});
	}
	const result = Object.values(messages.reduce((acc, cur) => Object.assign(acc, {[cur.id]: cur}), {}))
	return [...errMsgs, ...result];
};

const defaultProps = {
	shoppingCart: {
		events: [],
	},
};

function ShoppingCartCheckoutPage(propsIn) {
	const props = {...defaultProps, ...propsIn}
	const context = React.useContext(ThemeContext);
	const showContinueShoppingBtn = context.themeManager.valueOrDefault(
		'shopping-cart', 'disable-multi-events-booking', null, 'false') === 'false';
	// Placed here because we can't access context from reducer or mapStateToProps.
	const errors = constructTicketAddressErrors(props.ticketAddressErrors, context, props.errors);
	const style = {
		headline: {
			fontSize: context.themeManager
				.value('shopping-cart-checkout', 'headlineFontSize', 'font-size-500'),
			fontWeight: '300',
			textAlign: 'center',
			textTransform: 'uppercase',
			margin: '0 0 1em',
		},
		buttonContainer: {
			width: '100%',
			marginBottom: '2em',
			display: 'flex',
			justifyContent: 'center',
			'@media(min-width : 768px)': {
				width: '12em',
				marginLeft: 'auto',
				marginRight: 'auto',
				maxWidth: '100%',
				minWidth: '230px'
			},
		},
		linkContainer: {
			width: '100%',
			marginBottom: '2em',
			paddingLeft: '2.5em',
			paddingRight: '2.5em',
			textAlign: 'center',
			'@media(min-width : 768px)': {
				marginLeft: 'auto',
				marginRight: 'auto',
				textAlign: 'left',
			},
		},
	};
	const emptyShoppingCart = props.shoppingCart.events === null;
	const showCrossSelling = checkIfCrossSellingEnabled();

	return emptyShoppingCart ? (
		<EmptyShoppingCart/>
	) : (
		<div className="shopping-cart-checkout">
			<Errors
				errors={errors}
			/>
			<h1 style={style.headline}>Warenkorbübersicht</h1>
			<ShoppingCart shoppingCartEvents={props.shoppingCart.events}/>
			<OrderComment/>
			{showContinueShoppingBtn &&
				<div style={style.buttonContainer}>
					<ButtonEventsOverview
						btnText={context.themeManager.getThemeTextOrHardcodedDefault('continueShoppingBtnLabel')}
						label={"Der Button öffnet die Programmübersichtseite"}
						buttonContainerStyle={style.buttonContainer}
						btnLayout="link"
					/>
				</div>
			}
			{!showContinueShoppingBtn &&
				<div style={style.linkContainer}>
					<ButtonEventsOverview
						btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
						btnLayout="link"
					/>
				</div>
			}
			{showCrossSelling ? <CrossSellingEvent/> : <Separator/>}
			<CheckoutArea/>
			<HelpInfo/>
		</div>
	);
}

const RadiumShoppingCartCheckoutPage = radium(ShoppingCartCheckoutPage);

// ------------------------------
// Store Connection
// ------------------------------
const constructErrorMessages = (errors) => {
	const messages = [];
	for (const err of errors) {
		if (err.indexOf('shipmenttype_') > -1) {
			messages.push({
				message: 'Bitte wählen Sie eine gültige Versandart aus.',
				elementIdToLink: 'shipment_selection'
			});
		}
		if (err.indexOf('order_') > -1) {
			messages.push({message: 'Ihre Bemerkung enthält ungültige Zeichen', elementIdToLink: 'comment'});
		}
		if (err.indexOf('shipment_') > -1) {
			messages.push({
				message: 'Bitte korrigieren Sie ihre Versandadresse',
				elementIdToLink: 'shipping_address_form'
			});
		}
		if (err.indexOf('legal_') > -1) {
			messages.push({
				message: 'Bitte korrigieren Sie ihre Rechnungsadresse',
				elementIdToLink: 'billing_address_form'
			});
		}
	}
	const result = Object.values(messages.reduce((acc, cur) => Object.assign(acc, {[cur.message]: cur}), {}))
	return [...result];
};

const mapStateToProps = (state) => {
	const errors = constructErrorMessages(state.eventPage.errors);
	const event = state.event.elements[state.event.selected] || {};
	const shoppingCart = state.shoppingCart.elements[state.merchant.merchantId];

	return {
		isLoading: state.event.isLoading,
		orderIsLoading: state.order.isLoading,
		event,
		customer: state.customer,
		selectedShipmentType: state.checkoutPage.selectedShipmentType,
		selectedPaymentType: state.checkoutPage.selectedPaymentType,
		shoppingCart,
		merchantId: state.merchant.merchantId,
		errors,
		ticketAddressErrors: state.ticketAddress.errors,
	};
};

export default connect(
	mapStateToProps,
)(RadiumShoppingCartCheckoutPage);
